import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import SummaryChart from '@/components/charts/summary-chart/summary-chart';
import { LEARNING_MAP_CONTENT_TYPE, DEFAULT_GOORU_CATALOG_SUBJECTS, INCLUDE_CONTENT_TYPES } from '@/utils/constants';
import MCIcon from '@/components/icons/mc-icon/mc-icon';
import ChartTable from './chart-table/chart-table';
import { ClassificationModel } from '@/models/taxonomy/classification';

@Component({
  name: 'summary-content',
  components: {
    'material-icon': GoogleMaterialIcon,
    'mc-icon': MCIcon,
    'summary-chart': SummaryChart,
    'chart-table': ChartTable,
  },
})

export default class SummaryContent extends Vue {

  @Prop()
  private activeComponent: any;

  @Prop()
  private filterParams: any;

  private initiateWatcher!: any;

  private defaultSubject: any = DEFAULT_GOORU_CATALOG_SUBJECTS;

  private get summaryCatalogFooter() {
    return LEARNING_MAP_CONTENT_TYPE
      .filter((item: any) => item.isSummaryFooter)
      .sort((a: any, b: any) => a.isSummaryFooterSeq - b.isSummaryFooterSeq);
  }

  private get summaryResources() {
    return this.$store.state.activityStore.summaryResource;
  }

  private get summaryQuestions() {
    return this.$store.state.activityStore.summaryQuestion;
  }

  private get learnerContent() {
    return this.$store.state.activityStore.learnerContent;
  }

  private get categoryList() {
    return this.$store.state.activityStore.categoryList;
  }

  private get subjectList() {
    return this.$store.state.activityStore.summarySubjects;
  }

  private get subjectLearnerContent() {
    return this.$store.state.activityStore.learnerContent.param || {};
  }

  private defaultClassification: string = 'k_12';

  private disabledSubjectDistribution: boolean = false;

  @Watch('categoryList')
  private initialClassicationLoad(value: ClassificationModel[]) {
    if (value.length) {
      const defaultClassification: any = value.find(
        (classification: ClassificationModel) => classification.is_default);
      if (defaultClassification) {
        this.defaultClassification = defaultClassification.id;
        this.getSubjectList(defaultClassification.id);
      }
    }
  }

  private activated() {
    this.initiateWatcher = this.$watch('filterParams',
      (value) => this.onChangeParams(value), { deep: true });
    this.onChangeParams(this.filterParams);
  }


  private deactivated() {
    this.initiateWatcher();
  }


  private onLoad(filterParams = this.filterParams) {
    const params: any = {
      resource: filterParams,
      question: filterParams,
    };
    const classificationId = filterParams['flt.subjectClassification']
      ? filterParams['flt.subjectClassification'] : this.defaultClassification;
    if (classificationId) {
      this.getSubjectList(classificationId);
    }
    this.$store.dispatch('activityStore/fetcSummaryCatalog', params);
  }

  private loadLearnerContents(subjectId: string) {
    const subjectContent = this.learnerContent[subjectId];
    const total = (name: any) => subjectContent && subjectContent.totalHitCount[name]
      ? subjectContent.totalHitCount[name] : 0;
    const contentCounts = [
      {
        name: 'questions',
        value: total('question'),
        colorCode: '#BFE1DB',
      },
      {
        name: 'resources',
        value: total('resource'),
        colorCode: '#8ED1C7',
      },
      {
        name: 'assessments',
        value: total('assessment'),
        colorCode: '#58B8AA',
      },
      {
        name: 'collections',
        value: total('collection'),
        colorCode: '#07A392',
      },
      {
        name: 'courses',
        value: total('course'),
        colorCode: '#008D7C',
      },
    ];
    return contentCounts;
  }

  private getSubjectList(classification: string) {
    this.$store.dispatch('activityStore/fetchSummarySubjects', classification).then(() => {
      const learnerParams: any = {};
      this.defaultSubject.forEach((subject: any) => {
        learnerParams[subject.id] = {
          includeContentTypes: INCLUDE_CONTENT_TYPES,
          subject: subject.id,
          subjectClassification: classification,
        };
      });
      this.$store.dispatch('activityStore/fetachLearnerContent', learnerParams);
    });
  }

  private onChangeParams(value: any) {
    this.disabledSubjectDistribution = false;
    if (value.q !== '*' || value['flt.subject']) {
      this.disabledSubjectDistribution = true;
      this.$store.dispatch('activityStore/fetachLearnerContent', { param: value });
    }
    this.onLoad(value);
  }

}
